import React from "react";
import AdfoxAdaptive from "./AdFoxAdaptive";
import { selectVariant } from "../../utils/adVariant";

export function AdfoxBlock({ isFull, isDesktop, options, className = "adfox" }) {
    const option = selectVariant(options, isFull, isDesktop);

    if (!option) {
        return null;
    }

    return <AdfoxAdaptive options={option} className={className} />;
}
